import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { useMessages } from '../../context/MessagesContext';
import { Button } from '../common/Button';

export function SelfDestructModal() {
  const { isSelfDestructModalOpen, setIsSelfDestructModalOpen, setPendingSelfDestructMessage } = useUISettings();
  const { sendMessage, pendingSelfDestructMessage } = useMessages();
  const [expiryMinutes, setExpiryMinutes] = useState(5);
  
  if (!isSelfDestructModalOpen) return null;
  
  const handleConfirm = () => {
    sendMessage(pendingSelfDestructMessage, true, expiryMinutes * 60);
    setPendingSelfDestructMessage('');
    setIsSelfDestructModalOpen(false);
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Self-Destructing Message</h3>
        
        <p className="text-sm text-gray-600 mb-4">
          Set how long the message should be visible:
        </p>
        
        <select
          value={expiryMinutes}
          onChange={(e) => setExpiryMinutes(parseInt(e.target.value))}
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
        >
          <option value={1}>1 minute</option>
          <option value={5}>5 minutes</option>
          <option value={10}>10 minutes</option>
          <option value={30}>30 minutes</option>
          <option value={60}>1 hour</option>
          <option value={1440}>24 hours</option>
        </select>
        
        <div className="flex justify-end space-x-4">
          <Button onClick={() => setIsSelfDestructModalOpen(false)} variant="secondary">
            Cancel
          </Button>
          <Button 
            onClick={handleConfirm}
            variant="danger"
          >
            Send Self-Destructing Message
          </Button>
        </div>
      </div>
    </div>
  );
}